import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { Role, User } from '@lib/shared/models/user.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EditContentGuard {
  constructor(
    private router: Router,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore,
  ) {}
  async canActivate(): Promise<boolean> {
    const auth = await this.afAuth.currentUser;
    if (!auth) {
      this.router.navigate(['/login']);
      return false;
    }

    const userDoc = this.afs.doc<User>(`users/${auth.uid}`);
    const user = await firstValueFrom(userDoc.valueChanges());

    if (!user) {
      this.router.navigate(['/page-not-found']);
      return false;
    }

    const rolePath = typeof user?.role === 'string' ? user.role : user?.role?.path;

    if (!rolePath) {
      this.router.navigate(['/page-not-found']);
      return false;
    }

    const role = await firstValueFrom(this.afs.doc<Role>(rolePath).valueChanges());
    if (role && !role.permissions.editContent) {
      this.router.navigate(['/page-not-found']);
      return false;
    }

    return true;
  }
}
